import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { PageShell, PageHero } from "@/components/site/page-shell";
import { CTABanner } from "@/components/sections/cta-banner";
import { ProductGrid } from "@/components/storefront/product-grid";
import { fetchProductsByKind } from "@/lib/storefront";

export const Route = createFileRoute("/software")({
  component: SoftwarePage,
  head: () => ({
    meta: [
      { title: "Software — ERP, POS, CRM & more — CoderLity" },
      { name: "description", content: "Buy or subscribe to CoderLity SaaS — ERP, POS, CRM, HRM, accounting, inventory and industry suites." },
      { property: "og:url", content: "/software" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/software" }],
  }),
});

function SoftwarePage() {
  const { data: products = [], isLoading } = useQuery({
    queryKey: ["storefront", "products", "software"],
    queryFn: () => fetchProductsByKind("software"),
  });

  return (
    <PageShell>
      <PageHero eyebrow="Software" title="Business software, ready to deploy" sub="Subscribe monthly, yearly or buy a lifetime license. Self-host or managed cloud." />
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          {isLoading ? (
            <div className="text-center text-muted-foreground">Loading products…</div>
          ) : (
            <ProductGrid products={products} emptyMessage="Software catalog coming soon." />
          )}
        </div>
      </section>
      <CTABanner />
    </PageShell>
  );
}
